/**
 * @module FE-CU20_ニックネーム設定画面_表示地区
 */
import Header from '../../../../components/header/Header.vue';
import BreadCrumbList from '../../../../components/breadCrumb/List.vue';
import ListPanel from '../../../../components/listPanel/ListPanel.vue';
import MobileFooter from '../../../../components/footer/MobileFooter.vue';
import PcPageTitle from '../../../../components/pcPageTitle/PcPageTitle.vue';
import PCFooter from '@/components/footer/PCFooter.vue';
import CONSTANTS from '../../../../constants';

const PAGE_ID = 'FE-CU20';

export default {
  name: 'Nickname',
  components: {
    Header,
    BreadCrumbList,
    ListPanel,
    MobileFooter,
    PcPageTitle,
    PCFooter,
  },
  data(vm) {
    return {
      title: vm.$vuetify.lang.t('$vuetify.FECU20ニックネーム設定画面.ニックネーム設定'),
      hintText: vm.$vuetify.lang.t('$vuetify.メッセージ一覧.FECU20ニックネーム設定画面.C0002'),
      panelTitle: {
        place: ' - ',
        type: '$vuetify.FECU20ニックネーム設定画面.対象地区',
        typeIsBefore: true,
      },
      isDisabled: true,
      isValid: true,
      nickname: null,
      dialog: false,
      displayAreaList: [],
      nickName: '',
      nickNameError: '',
      modified: '',
      CONSTANTS: CONSTANTS,
      //ページの表示タイミング
      isShowPage: false,
    };
  },
  computed: {
    nickNameRule() {
      return [
        !!this.nickName ||
          this.$vuetify.lang.t('$vuetify.メッセージ一覧.FECU20ニックネーム設定画面.E0001'),
      ];
    },
    i18nItems(vm) {
      return {
        title: vm.$vuetify.lang.t('$vuetify.FECU20ニックネーム設定画面.ニックネーム設定'),
        hintText: vm.$vuetify.lang.t('$vuetify.メッセージ一覧.FECU20ニックネーム設定画面.C0002'),
        panelTitle: vm.$vuetify.lang.t('$vuetify.FECU20ニックネーム設定画面.対象地区'),
      };
    },
    /**
     * 設定ボタン活性制御
     */
    checkValid() {
      if (this.isValid && this.nickName != '') {
        return false;
      }
      return true;
    },
  },
  async mounted() {
    window.scroll({ top: 0, behavior: 'smooth' });
    this.$_pvCount(PAGE_ID);

    // 自動ログアウト
    this.$_setTimer();
    this.$_setEvents(this.$_resetTimer);

    if (this.$store.getters['isLoggedIn']) {
      await this.$refs.header.APP_CU0201();
    }

    //何故か、以下通信でローディングマークを出してるので、ここで画面表示
    this.isShowPage = true;

    let param = '/api/setDisplayDistrictNickname/init';

    let queries = {
      token: sessionStorage.getItem('token'),
      terminalInfo: localStorage.getItem('terminalInfo')
        ? localStorage.getItem('terminalInfo')
        : '',
      customerNumber: this.$store.state.customerNumber,
      districtSplitNumber: this.$store.state.districtSplitNumber,
    };

    let method = 'post';

    await this.APP_CU2001(param, queries, method);
  },
  /** @type {Methods} */
  methods: {
    /**
     * 表示地区情報設定データ取得(APP_CU2001)
     * @param {*} param URLパラメータ
     * @param {*} queries リクエストのパラメータ
     * @param {*} method リクエストメソッド
     * @returns レスポンス
     */
    APP_CU2001: async function (param, queries, method) {
      this.$_setLoading(true);

      let apiData = '';
      await this.$store
        .dispatch(`requestApi/${method}ApiInfoAction`, {
          url: param,
          params: queries,
        })
        .then(() => {
          apiData = this.$store.getters[`requestApi/${method}ApiInfo`];
          // サンプルデータ
          // apiData = {
          //   contentsInfo: {
          //     displayDistrictInfo: {
          //       displayDistrictNickname: "自宅",
          //       usagePlan: 0,
          //       customerNumber: "51-1234567",
          //       securityDestinationName: "警備先1",
          //       districtSplitNumber: "0001",
          //       districtSplitName: "地区名1",
          //     },
          //   },
          //   modified: "",
          // };
        })
        .catch((error) => {
          this.isValid = false;
          this.$_abnormality(error.response.status);
        })
        .finally(() => {
          this.$_setLoading(false);
        });

      const targetItem = apiData.contentsInfo.displayDistrictInfo;
      const labels = {
        usagePlan: '$vuetify.FECU20ニックネーム設定画面.対象地区詳細表示領域.利用プラン',
        customerNumber: '$vuetify.FECU20ニックネーム設定画面.対象地区詳細表示領域.お客様番号',
        securityDestinationName:
          '$vuetify.FECU20ニックネーム設定画面.対象地区詳細表示領域.警備先名',
        districtSplitNumber: '$vuetify.FECU20ニックネーム設定画面.対象地区詳細表示領域.地区番号',
        districtSplitName: '$vuetify.FECU20ニックネーム設定画面.対象地区詳細表示領域.地区名',
      };
      const targetKeys = [
        'usagePlan',
        'customerNumber',
        'securityDestinationName',
        'districtSplitNumber',
        'districtSplitName',
      ];
      const planTitles = {
        [CONSTANTS.HOME_SECURITY_USAGE_PLAN.ONLINE_MONITORING_PLAN]:
          '$vuetify.コード.利用プランID.オンライン監視プラン',
        [CONSTANTS.HOME_SECURITY_USAGE_PLAN.EMERGENCY_ASSISTANCE_ON_DEMAND_PLAN]:
          '$vuetify.コード.利用プランID.依頼かけつけプラン',
        [CONSTANTS.HOME_SECURITY_USAGE_PLAN.EMERGENCY_ASSISTANCE_ON_DEMAND_PLAN_NO_DEVICE]:
          '$vuetify.コード.利用プランID.依頼かけつけプラン',
        [CONSTANTS.HOME_SECURITY_USAGE_PLAN.SELF_MONITORING_PLAN]:
          '$vuetify.コード.利用プランID.セルフ監視プラン',
        [CONSTANTS.HOME_SECURITY_USAGE_PLAN.SELF_MONITORING_PLAN_NO_DEVICE]:
          '$vuetify.コード.利用プランID.セルフ監視プラン',
      };

      Object.keys(targetItem).map((key) => {
        if (targetKeys.includes(key)) {
          let text = targetItem[key];
          if (key === 'usagePlan') {
            text = planTitles[targetItem[key]];
          }
          if (key === 'districtSplitNumber') {
            if (targetItem[key] === '') {
              return;
            }
            if (targetItem[key] === '    ') {
              text = '$vuetify.FECU20ニックネーム設定画面.メイン地区';
            }
          }
          this.displayAreaList = [
            ...this.displayAreaList,
            {
              title: labels[key],
              text: text,
              isVuetifyKey: text.includes('$'),
            },
          ];
        }
      });

      this.modified = apiData.contentsInfo.modified;

      this.panelTitle.place =
        ' - ' + apiData.contentsInfo.displayDistrictInfo.displayDistrictNickname;

      this.nickName = apiData.contentsInfo.displayDistrictInfo.displayDistrictNickname;

      return apiData;
    },
    /**
     * 登録完了ダイアログ表示処理
     */
    async callSaveMessageDialog() {
      const status = await this.APP_CU2002();
      if (status !== 200) {
        return;
      }
      await this.$informationDialog('$vuetify.メッセージ一覧.FECU20ニックネーム設定画面.C0003');
      this.back();
    },
    /**
     * 登録確認ダイアログ表示処理
     */
    async callSaveAgreementDialogDialog() {
      const result = await this.$agreementDialog(
        '$vuetify.agreementDialog.確認',
        '$vuetify.メッセージ一覧.FECU20ニックネーム設定画面.C0001',
        '$vuetify.agreementDialog.いいえボタン',
        '$vuetify.agreementDialog.はいボタン'
      );
      if (result) {
        this.callSaveMessageDialog();
      }
    },
    /**
     * 表示地区ニックネーム設定(APP_CU2002)
     */
    APP_CU2002: async function () {
      this.$_setLoading(true);
      const url = '/api/setDisplayDistrictNickname/setNickname';
      // const url = "post";
      const queries = {
        token: sessionStorage.getItem('token'),
        terminalInfo: localStorage.getItem('terminalInfo')
          ? localStorage.getItem('terminalInfo')
          : '',
        customerNumber: this.$store.state.customerNumber,
        districtSplitNumber: this.$store.state.districtSplitNumber,
        displayDistrictNickname: this.nickName,
        modified: this.modified,
      };
      const method = 'post';
      return await this.$store
        .dispatch(`requestApi/${method}ApiInfoAction`, {
          url: url,
          params: queries,
        })
        .then((response) => {
          return response.status;
        })
        .catch((error) => {
          if (error.message.includes('400')) {
            this.$errorDialog('$vuetify.メッセージ一覧.FECU20ニックネーム設定画面.E0004');
          } else {
            this.$_abnormality(error.response.status);
          }
          return error.response.status;
        })
        .finally(() => {
          this.$_setLoading(false);
        });
    },
    /**
     * 戻る処理
     */
    back() {
      this.$store.commit('setBackButtonFlag', { backButtonFlag: true });
      this.$router.back();
    },
  },
};
